import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { BODY_MEDIUM_STYLE } from '../styles'
import Icon from '../Icon'

const useStyles = createUseStyles({
  button: {
    ...BODY_MEDIUM_STYLE,
    height: 64,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    paddingLeft: 16,
    paddingRight: 16,
  },
  queue: {
    backgroundColor: 'rgba(203, 166, 122, 0.56)',
    border: '1px solid rgba(144, 115, 79, 0.24)',
    color: '#363432',
  },
  queueNumber: {
    color: 'rgba(54, 52, 50, 0.56)',
  },
  detected: {
    backgroundColor: 'rgba(54, 52, 50, 0.8)',
    color: 'white',
  },
  detectedNumber: {
    color: 'rgba(255, 255, 255, 0.56)',
  },
  icon: {
    color: 'rgba(144, 115, 79, 0.24)',
  },
})

interface Props {
  type: 'queue' | 'detected'
  titleStyle: 'short' | 'long'
  number: number
  onClick: () => void
  className?: string
}

export const ProductPickerButton: FC<Props> = flowMax(
  addDisplayName('ProductQueueButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ type, titleStyle, number, onClick, classes, className, t }) => (
    <button
      onClick={onClick}
      className={cx(
        classes.button,
        type === 'queue' ? classes.queue : classes.detected,
        className
      )}
    >
      <Icon
        name={type === 'queue' ? 'queuedProducts' : 'detectedProducts'}
        className={classes.icon}
      />
      <div>
        <span>
          {t(
            type === 'queue'
              ? `admin.post.productsInQueue.${titleStyle}`
              : `admin.post.detectedProducts.${titleStyle}`
          )}{' '}
        </span>
        <span
          className={
            type === 'queue' ? classes.queueNumber : classes.detectedNumber
          }
        >
          {number}
        </span>
      </div>
    </button>
  )
)
